import {
  addQueryParams,
  FlexRowCenterVertical,
  useRouter,
} from '@main/core-ui';
import { DefinedMessage } from '@main/internationalization';
import { A } from '@main/pc-core-components';
import {
  SectionWrapper,
  SelectDataSubjectType,
  SelectDataSubjectTypeOption,
  SelectPartition,
} from '@main/privacy-center/src/components';
import { selectDataSubjects } from '@main/privacy-center/src/containers/ActiveDataSubject/selectors';
import { selectSessionProfile } from '@main/privacy-center/src/containers/App/selectors';
import {
  useLoginRedirection,
  usePartition,
} from '@main/privacy-center/src/hooks';
import { sp } from '@main/theme';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { globalSettingsMessages } from './messages';

export interface GlobalSettingsProps {
  /** default selected data subject type */
  subject: SelectDataSubjectTypeOption;
  /** Description text for the section */
  description?: DefinedMessage;
  /**
   * Callback to handle the change of subject type
   */
  onSubjectTypeChange?: (type: SelectDataSubjectTypeOption) => void;
}
/**
 * Component to select the Preference Store partitions
 */
export const GlobalSettings: React.FC<GlobalSettingsProps> = ({
  subject,
  description,
  onSubjectTypeChange,
}) => {
  const { formatMessage } = useIntl();
  const { location, redirect } = useRouter();
  const sessionProfile = useSelector(selectSessionProfile);
  const [{ partitionOptions, showPartition }] = usePartition();
  const redirectTo = useLoginRedirection();
  redirectTo({ key: 'redirectTo', value: 'log-in' }, 'modal=log-in');

  const dataSubjects = useSelector(selectDataSubjects);
  return (
    <>
      {((partitionOptions.length > 1 && showPartition) ||
        (!sessionProfile && dataSubjects.length > 1)) && (
        <SectionWrapper
          description={formatMessage(
            description ||
              (sessionProfile
                ? globalSettingsMessages.loggedInMessage
                : globalSettingsMessages.loggedOutMessage),
            {
              logIn: (
                <A
                  type="secondary"
                  onClick={() =>
                    redirect(
                      addQueryParams(location, {
                        modal: 'select-subject',
                        redirectTo: `${location.pathname}?redirectTo=log-in`,
                      }),
                    )
                  }
                >
                  {formatMessage(globalSettingsMessages.logIn)}
                </A>
              ),
            },
          )}
        >
          <FlexRowCenterVertical
            style={{
              fontWeight: 600,
              gap: sp(4),
            }}
          >
            {!sessionProfile && (
              <SelectDataSubjectType
                value={subject}
                onChange={(value) => onSubjectTypeChange?.(value)}
              />
            )}
            {partitionOptions.length > 1 && <SelectPartition />}
          </FlexRowCenterVertical>
        </SectionWrapper>
      )}
    </>
  );
};
